export default {
  permissions: state => state.permissions
}
